/* eslint-disable react/no-array-index-key */
import ArticleItemLists from '../articleItemLists/ArticleItemLists';
import img1 from '../../assets/images/png/article1.png';
import img2 from '../../assets/images/png/article2.png';
import img3 from '../../assets/images/png/article3.png';
import './latestArticles.css';

const data = [
  {
    image: img1,
    status: [{ statusProgress: 'verified', statusText: 'Evidence Based' }],
    heading: 'Make the Most of Your Safer-at-Home Summer',
    btnText: 'READ MORE',
    link: '/',
    desc: 'As we face continued social distancing and safer-at-home guidelines, here are some creative ways to keep...'
  },
  {
    image: img2,
    status: [{ statusProgress: 'verified', statusText: 'Evidence Based' }],
    heading: 'Make the Most of Your Safer-at-Home Summer',
    btnText: 'READ MORE',
    link: '/',
    desc: 'As we face continued social distancing and safer-at-home guidelines, here are some creative ways to keep...'
  },
  {
    image: img3,
    status: [{ statusProgress: 'verified', statusText: 'Evidence Based' }],
    heading: 'Make the Most of Your Safer-at-Home Summer',
    btnText: 'READ MORE',
    link: '/',
    desc: 'As we face continued social distancing and safer-at-home guidelines, here are some creative ways to keep...'
  }
];

function LatestArticles() {
  return (
    <div className="latestArticles">
      {data.map((list, index) => {
        const {
          image,
          status = [],
          heading,
          btnText,
          link,
          desc,
          drName
        } = list;
        return (
          <div key={index}>
            <ArticleItemLists
              image={image}
              status={status}
              heading={heading}
              btnText={btnText}
              link={link}
              desc={desc}
              leftCol={3}
              rightCol={8}
              drName={drName}
            />
          </div>
        );
      })}
    </div>
  );
}

export default LatestArticles;
